import { Module } from 'vuex';
import { StopWatch } from '@signing-page/tracking/helpers/tracking.helper';
import { actions } from '@signing-page/tracking/store/tracking.actions';
import { mutations } from '@signing-page/tracking/store/tracking.mutations';
import { getters } from '@signing-page/tracking/store/tracking.getters';
import { IRootState } from '@signing-page/store/store';
import { IDocumentPage } from '@lib-shared/types/document-page';

export const namespace = 'tracking';

export interface ITrackingState {
  currentDocumentPages: IDocumentPage[];
  pageViewStopWatch: StopWatch;
  pageViewStopWatchPaused: boolean;
  suspendPageTracking: boolean;
  trackingDisabled: boolean;
}

export const state: ITrackingState = {
  currentDocumentPages: [],
  pageViewStopWatch: new StopWatch(),
  pageViewStopWatchPaused: true,
  suspendPageTracking: false,
  trackingDisabled: true,
};

const namespaced = true;

export const tracking: Module<ITrackingState, IRootState> = {
  actions,
  namespaced,
  mutations,
  getters,
  state,
};
